export type PendingLevelRef = {
  id: number
  uid: string
  name: string
}

/**
 * Texto curto do cadeado quando o nível é bloqueado por uma lista de níveis
 * exigidos. Conta, e **não nomeia** — quatro nomes não cabem na linha do item
 * a 375px. Os nomes aparecem no alerta, que tem espaço e o mesmo botão dos
 * demais bloqueios.
 */
export const getPendingLevelsHint = (
  requiredIds: number[] | undefined,
  isFinished: (id: number) => boolean
): string | null => {
  const ids = requiredIds ?? []
  if (ids.length === 0) return null

  const pending = ids.filter(id => !isFinished(id)).length
  if (pending === 0) return null

  return pending === 1
    ? `Falta 1 de ${ids.length}`
    : `Faltam ${pending} de ${ids.length}`
}

/** Primeiro exigido ainda pendente, na ordem configurada pelo Produtor. */
export const getFirstPendingLevelRef = (
  requiredIds: number[] | undefined,
  isFinished: (id: number) => boolean,
  resolveLevel: (id: number) => PendingLevelRef | undefined
): PendingLevelRef | null => {
  for (const id of requiredIds ?? []) {
    if (isFinished(id)) continue

    const level = resolveLevel(id)
    if (level) return level
  }

  return null
}

/** Corpo do alerta: contagem + lista dos pendentes. */
export const getPendingLevelsAlertMessage = (
  hint: string,
  pendingNames: string[]
): string => {
  if (pendingNames.length === 0) return hint

  const list = pendingNames.map(name => `• ${name}`).join('\n')

  return `${hint}\n\nAinda falta concluir:\n${list}`
}
